class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.search__input');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

// Shopify's semantic search pads every plain query with loosely related
// products, so "horizon" returned 151 results for 28 real matches. Quoting each
// word returns real matches only and still matches plurals. When that finds
// nothing, main-search.liquid reruns the plain query so typos still get results.
const SEARCH_WORD_ALIASES = { mojri: 'mojdi', mojris: 'mojdi', mojari: 'mojdi', mojaris: 'mojdi' };

const exactSearchQuery = (value) =>
  value
    .replace(/"/g, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => `"${SEARCH_WORD_ALIASES[word.toLowerCase()] || word}"`)
    .join(' ');

document.addEventListener('submit', (event) => {
  const form = event.target;
  const input = form.elements.q;
  if (event.defaultPrevented || !input || !form.matches('[role="search"]')) return;

  const query = exactSearchQuery(input.value);
  if (!query) return;

  event.preventDefault();
  const params = new URLSearchParams(new FormData(form));
  params.set('q', query);
  window.location.assign(`${form.getAttribute('action')}?${params}`);
});

// Links straight to /search?q=... skip the form, so give them the same exact
// search. exact=0 marks the plain rerun, which must stay as it is.
const searchPageUrl = new URL(window.location.href);
const searchPageQuery = searchPageUrl.searchParams.get('q');
if (
  searchPageUrl.pathname.endsWith('/search') &&
  searchPageQuery?.trim() &&
  !/[":]/.test(searchPageQuery) &&
  searchPageUrl.searchParams.get('exact') !== '0'
) {
  searchPageUrl.searchParams.set('q', exactSearchQuery(searchPageQuery));
  window.location.replace(searchPageUrl);
}
